import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import axios from 'axios'

interface AuthStore {
  accessToken?: string
  refreshToken?: string
  profile?: any
  hasFetchProfile?: boolean
  setAccessToken: (accessToken: string) => void
  removeAccessToken: () => void
  setRefreshToken: (refreshToken: string) => void
  removeRefreshToken: () => void
  setProfile: (profile: any) => void
  getProfile: () => Promise<{ success: boolean; data: any }>
  requestResetPassword: (email: string) => Promise<{ success: boolean; data: any }>
  resetPassword: (
    password: string,
    confirmPassword: string
  ) => Promise<{ success: boolean; data: any }>
  clearState: () => void
}

export const useAuthStore = create(
  persist<AuthStore>(
    (set, get) => ({
      accessToken: undefined,
      refreshToken: undefined,
      setAccessToken: (accessToken: string) => set({ accessToken }),
      removeAccessToken: () => set({ accessToken: undefined }),
      setRefreshToken: (refreshToken: string) => set({ refreshToken }),
      removeRefreshToken: () => set({ refreshToken: undefined }),
      setProfile: (profile: any) => set({ profile }),
      getProfile: async () => {
        try {
          const res = await axios.get('/Users/me', {
            headers: {
              Authorization: `Bearer ${get().accessToken}`,
            },
          })
          set({ profile: res.data, hasFetchProfile: true })

          return { success: true, data: res.data }
        } catch (err: any) {
          return {
            success: false,
            data: err?.response?.data?.message,
          }
        }
      },
      requestResetPassword: async (email: string) => {
        try {
          const formData = new FormData()
          formData.append('email', email)

          const res = await axios.post('/Users/forgot-password', formData)
          return { success: true, data: res.data }
        } catch (err: any) {
          return {
            success: false,
            data: err?.response?.data?.message?.toString() ?? 'Something went wrong',
          }
        }
      },
      resetPassword: async (password: string, token: string) => {
        try {
          const formData = new FormData()
          formData.append('newPassword', password)
          formData.append('token', token)

          const res = await axios.post('/Users/reset-password', formData)
          return { success: true, data: res.data }
        } catch (err: any) {
          return {
            success: false,
            data: err?.response?.data?.message?.toString() ?? 'Something went wrong',
          }
        }
      },
      clearState: () =>
        set({
          accessToken: undefined,
          refreshToken: undefined,
          profile: undefined,
        }),
    }),
    {
      name: 'paco-auth-storage',
      storage: createJSONStorage(() => localStorage),
      // @ts-ignore
      partialize: state => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
      }),
    }
  )
)
